import React, { useState } from 'react';
import { Col, Row } from 'antd';
import { motion } from 'framer-motion';
import { CatchReportSlider } from '../../common/components/sliders';
import { useGetAllCatcheReportsQuery } from '../../user_profile/querySlice/anglerCatchesSlice';

function LiveCatchReports() {
  const [nearViewport, setNearViewport] = useState(false);
  const { data: catches, isLoading } = useGetAllCatcheReportsQuery(undefined, {
    skip: !nearViewport,
  });

  return (
    <motion.section
      className='main_container_padding'
      aria-labelledby='home-live-catches-title'
      viewport={{ once: true, margin: '600px 0px' }}
      onViewportEnter={() => setNearViewport(true)}
    >
      <Row className='main_container_padding__content'>
        <Col span={24}>
          <h2
            id='home-live-catches-title'
            className='sb-blue-800 fs-30 gSemiBold mg-top-20 mg-bottom-0 row-center'
          >
            Live Catch Reports
            <span
              className='home-live-dot red-bg-400 brFull mg-left-10'
              aria-hidden='true'
            />
          </h2>
          <p className='gRegular grey-700 fs-20 mg-bottom-25'>
            swimbooker users can upload and manage their catch reports via their{' '}
            <span className='gSemiBold grey-900'>MySB</span> profile. Click for
            full catch report details.
          </p>
        </Col>
      </Row>
      <Row className='main_container_padding__content'>
        <Col span={24}>
          <CatchReportSlider
            isHomePage
            lakesData={catches?.catch_reports}
            loading={isLoading}
          />
        </Col>
      </Row>
    </motion.section>
  );
}

export default LiveCatchReports;
